import { useEffect, useState } from 'react'
import { throttle } from 'lodash'

export default function useScrollTop() {
  const [scrollTop, setScollTop] = useState(0)

  useEffect(() => {
    function handleScroll() {
      setScollTop(document.documentElement.scrollTop)
    }

    const debouncedHandleScroll = throttle(handleScroll, 100)

    document.addEventListener('scroll', debouncedHandleScroll)

    return () => {
      document.removeEventListener('scroll', debouncedHandleScroll)
    }
  }, [])

  return scrollTop
}
